export default "__VITE_ASSET__bf623037__"